<template>
    <UiHero id="sbHero" v-editable="blok" :blok="blok" />
</template>

<script setup>
defineProps({ blok: Object });
</script>

<style scoped lang="postcss">
#sbHero {
    @media screen and (max-width: 768px) {
        background: linear-gradient(180deg, #457abe, #519bd4) !important;
    }
    @apply py-6 md:pt-10 md:pb-4;
    :deep(.hero-container) {
        @apply min-h-[184px];

        .titles {
            @apply block;
            h1,
            h2 {
                @apply !block;
                text-shadow: 0 3px 3px rgba(0, 0, 0, 0.34);
            }

            h1 {
                @apply text-[1.175rem] max-md:leading-5 font-bold;
                @apply md:text-[2.6rem] md:tracking-[0.06rem];
            }

            h2 {
                @apply text-base md:text-2xl md:mt-4 font-semibold;
            }
        }
        @media screen and (max-width: 768px) {
            .searchbox-steps {
                @apply absolute flex -bottom-2.5;
            }
            .shuttle-search-form {
                @apply pb-0;
            }
        }
    }
}
</style>
